
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import StripePaymentMethodService from '@/Services/Subscription/StripePaymentMethodService';
import HelpTooltip from '@/components/HelpTooltip.vue';
import Icon from '@/components/Icons/Icon.vue';
import { ValidationProvider } from 'vee-validate';
import store from '@/store';

@Component({
  components: {
    HelpTooltip,
    Icon,
    ValidationProvider,
  },
})
export default class StripePaymentInformation extends Vue {
  @Prop({ type: StripePaymentMethodService })
  stripePaymentMethodService!: StripePaymentMethodService;

  @Prop({ type: Boolean, default: false })
  formStripeErrorMessage!: boolean;

  @Prop({ type: Boolean, default: false })
  showAbTestCardRadio!: boolean;

  get isCNV1609AbTest(): boolean {
    return store.state.auth.team.ab_tests?.includes('CNV_1609');
  }
  openFindVatModal = false;

  formErrorMessageCreditCardNumber: boolean = false;
  formErrorMessageCreditCardDate: boolean = false;
  formErrorMessageCreditCardCvcNumber: boolean = false;
  formErrorMessageCreditCardPostalCode: boolean = false;

  $refs!: {
    // Used for validation of the form data e.g. customer, address etc.
    CreditCardCvcNumber: any;
    CreditCardNumber: any;
    CreditCardDate: any;
    CreditCardPostalCode: any;
  };

  /**
   * If type changes due to clicking on payment selection trigger a change
   * of the payment method form.
   *
   * @param newVal
   * @param oldVal
   */
  @Watch('stripePaymentMethodService.paymentType', { deep: true, immediate: false })
  onPaymentMethodUpdate(newVal: string): void {
    console.log('PAYMENT METHOD UPDATE', newVal);
    this.formErrorMessageCreditCardNumber = false;
    this.formErrorMessageCreditCardDate = false;
    this.formErrorMessageCreditCardCvcNumber = false;
    this.formErrorMessageCreditCardPostalCode = false;
    this.formStripeErrorMessage = false;
    this.rebuildStripeForm(newVal);
  }

  mounted(): void {
    // Mount the payment form, we do this here because refs is not available in created()!
    this.rebuildStripeForm(this.stripePaymentMethodService.paymentType);
  }

  // Rebuild stripe elements form an exception is send_invoice which doesn't need stripe elements
  rebuildStripeForm(paymentMethodType: string): void {
    switch (paymentMethodType) {
      case 'card':
        this.stripePaymentMethodService.initCardForm();
        break;
      case 'sepa_debit':
        this.stripePaymentMethodService.initSEPAForm();
        break;
    }
  }

  hasClass(): void {
    const elementCreditCardNumber = this.$refs.CreditCardNumber;
    const elementCreditCardDate = this.$refs.CreditCardDate;
    const elementCreditCardCvcNumber = this.$refs.CreditCardCvcNumber;
    const elementCreditCardPostalCode = this.$refs.CreditCardPostalCode;

    this.formErrorMessageCreditCardNumber =
      elementCreditCardNumber.classList.contains('StripeElement--empty') ||
      elementCreditCardNumber.classList.contains('StripeElement--invalid');

    this.formErrorMessageCreditCardDate =
      elementCreditCardDate.classList.contains('StripeElement--empty') ||
      elementCreditCardDate.classList.contains('StripeElement--invalid');

    this.formErrorMessageCreditCardCvcNumber =
      elementCreditCardCvcNumber.classList.contains('StripeElement--empty') ||
      elementCreditCardCvcNumber.classList.contains('StripeElement--invalid');

    if (
      !this.isCNV1609AbTest &&
      !this.formErrorMessageCreditCardNumber &&
      (elementCreditCardPostalCode.classList.contains('StripeElement--empty') ||
        elementCreditCardPostalCode.classList.contains('StripeElement--invalid'))
    ) {
      this.formErrorMessageCreditCardPostalCode = true;
    }
  }
}
